<template>
  <section id="home-header">
    <!-- Content -->
    <div id="fullpage-main">

      <!-- Home Section -->
      <div id="home" class="section overlay-container text-center d-flex align-items-center" :style="'background-image: url(' + slides[0] + ')'">
          <div class="container-fluid content">
          	<div class="row">
          		<div class="col-lg-10 mx-auto">
	              <h2 class="text-xxl text-light font-2 white">Maximize your cabana revenue!</h2>
	              <p class="text-l font-2 white">Inventory and Reservation Management | Automated Dynamic Pricing | Real-time Accounting and Reporting</p>
              </div><!-- end .col-lg-10 -->
            </div><!-- end .row -->
          </div><!-- end .container-fluid -->
      </div>

      <!-- Features & Benefits Section -->
      <div id="features" class="section white" :style="'background-image: url(' + slides[1] + ')'">
            <div class="container content box-middle">
                <div class="row">
                    <div class="col-lg-6">
                      <h2 class="text-l text-light font-2 white">Features & Benefits</h2>
                          <div class="divider white"></div>
                          <ul class="text-m">
  	                         <li>Capture cabana reservations via the OpenCabana website or mobile application, an embeddable widget that can added to your hotels website</li>
                             <li>Know which cabanas are available in real-time and receive alerts when cabanas are turned over</li>
  	                         <li>Avoid under-the-table and unauthorized cabana rentals by staff</li>
  	                         <li>Price your cabanas based on location, date range or occupancy levels</li>
  	                          <li>Get text or email alerts for comps or discounts and no-shows or cancellations</li>
  	                          <li>Auto-generate and send email and text discount offers</li>
  	                          <li>Waitlist option with availability notifications</li>
  	                          <li>Monitor sales in real-time and generate guest activity and revenue reports</li>
                            </ul>
                          </div><!-- end .col-lg-4 -->
                          <div class="col-lg-6">
                          <h2 class="text-l text-light font-2 white">Easy Setup & Minimal Training</h2>
                            <div class="divider white"></div>
                            <ul class="text-m">
                              <li>No access to any hotel systems needed</li>
  	                          <li>Minimal tech skills and staff training required</li>
                              <li>OpenCabana is a software as a service (SaaS) solution requiring no software installation and can on your existing computers</li>
  	                          <li>No need for a POS system. OpenCabana’s mobile checkin tablets can process payments and directly deposit payments into your hotels operating account instantly</li>
  	                          <li>You only pay for usage based on the number of reservations managed through the system</li>
                            </ul>
                          </div><!-- end .col-lg-6 -->
                        <!-- end .col-lg-4 -->
                </div><!-- end .row -->
            </div>
        </div>

      <!-- How it Works Section -->
      <!-- <div class="section overlay-container white text-center" :style="'background-image: url(' + slides[2] + ')'">
          <div class="container content box-middle">
              <div class="row">
              </div>
          </div>
      </div> -->

      <!-- Features & Benefits Section -->
      <!-- <div class="section overlay-container white" :style="'background-image: url(' + slides[3] + ')'">
          <div class="container content box-middle">
              <div class="row">
                  <div class="col-12 text-center">
                    <div class="col-lg-6">
                    </div>
                  </div>
              </div>
          </div>
      </div> -->

      <!-- Contact Us Section -->
      <div id="contact_us" class="section white overlay-container text-center" :style="'background-image: url(' + slides[4] + ')'">
          <div class="container content box-middle">
            <div class="row">
              <div class="col-12 text-center">
                <p class="text-xl font-2 white margin-bottom" >Schedule a 15 minute demo!</p>
              </div><!-- end .col-12 -->
            </div><!-- end .row -->
                      <div class="row">
                          <div class="col-md-6">
                              <p class="text-l font-2 white">OpenCabana, LLC</p>
                              <p class="font-2 text-m">
                                  1616 SE 8th Street,<br />
                                  Fort Lauderdale, Florida 33316<br />
                              </p>
                          </div>
                          <div class="col-md-6">
                            <p class="text-l font-2 white">Contact Us</p>
                            <p class="font-2 text-m">(+1) 954-300-4445<br>
                            corp@opencabana.com</p>
                          </div>
                      </div>

                  </div>
              </div>
          </div>
      </div><!-- end .section -->

    </div>

  </section>
</template>

<script>
import moment from 'moment'
// import { getLocationsPulldown } from '@/api/home'
export default {
  name: 'Home',
  data() {
    return {
      slideArrow: 'never',
      slideIndicator: 'none',
      image: "https://opencabana.com/assets/images/diplo.jpg",
      slides: [
        // require('assets/images/diplo.jpg'),
        require('assets/images/hd-1.jpg'),
        require('assets/images/hd-2.jpg'),
        require('assets/images/hd-3.jpg'),
        require('assets/images/hd-4.jpg'),
        require('assets/images/hd-5.jpg')
      ]
    }
  },
  mounted() {
    // this.getLocations()
  }
}
</script>
<style  lang="scss" scoped>
.margin-bottom{
  margin-bottom:100px;
  @media only screen and (max-width: 420px) {
      margin-bottom:50px;
    }
}
</style>


// WEBPACK FOOTER //
// index.vue?11512fee